import { useContestContext } from '../context/ContestContext/ContestContext';

export const useIsContestMarketplaceEnabled = (): boolean => {
  const { contest } = useContestContext();

  return !!contest?.marketplace_enabled;
};
